// AuthContext.js
import { createContext, useContext, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../store/slices/auth.slice";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);

  const detail = useMemo(() => {
      return user ;
    }, [user]);


  const userConnected = detail

  const handleLogout = () => {
    dispatch(logout());
    window.location.reload();
  };

  return (
    <AuthContext.Provider value={{ userConnected, handleLogout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
